export default __webpack_public_path__ + "static/media/primary-tick.76c56482.svg";